let baseURL; // 接口地址获取
// 区分生产环境和开发环境时的接口地址
// TODO: 配置ENV以及ENV.local来使不同开发者使用不同的开发url
baseURL = process.env.REACT_APP_BASE_API;

export default{
    baseURL   
}